var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-col',{staticClass:"pcr-current-title",attrs:{"span":24}},[(_vm.current)?_c('div',[_c('h1',[(_vm.current.Type == 'User')?_c('span',[_vm._v("Utilisateur : ")]):_vm._e(),_vm._v(_vm._s(_vm.title))])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e691dd8","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/visual/pcr-current-title.vue
// module id = 608
// module chunks = 0